import { Component, ViewEncapsulation } from '@angular/core';

@Component({
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'report-header',
    },
    selector: 'ndt-report-output-header-bar',
    styleUrls: ['./report-output-header-bar.component.scss'],
    templateUrl: './report-output-header-bar.component.html',
    standalone: false
})
export class ReportOutputHeaderBarComponent {}
